import React from 'react';
import * as S from '../style';

import ProductInfo from '../ProductInfo';
import { DealActionButtons } from './DealActionButtons';
import { useDealItemPresenter } from './DealItem.presenter';
import { useDealActionButtonsPresenter } from './DealActionButtons.presenter';
import { AreaInfo, ReactTooltipStyled } from 'components/modules/MainAnketa/MainAnketa.styles';

export const DealItem = ({ deal, carInstance, application, color, secondColor }) => {
  const {
    bank_details,
    bankId,
    bankName,
    boldItem,
    checks,
    commentary,
    dealer_details,
    dealParams,
    state,
    hasLeasing,
  } = useDealItemPresenter({ deal, carInstance, application });
  const actionButtonsPresenter = useDealActionButtonsPresenter({ deal, application });

  return (
    <>
      {!checks.isAprove ? (
        <S.DealItemStatusContainer
          isShowButton={actionButtonsPresenter.isShowActionButton}
          onMouseEnter={actionButtonsPresenter.handleMouseEnter}
          onMouseLeave={actionButtonsPresenter.handleMouseLeave}
          color={color}
          secondColor={secondColor}
        >
          {actionButtonsPresenter.isShowActionButton && (
            <DealActionButtons buttons={actionButtonsPresenter.buttons} />
          )}
          <S.DetailCell>
            <S.BankLogoIcon type="cps" id={bankId} />
            {bankName}
          </S.DetailCell>
          {state === 'sent-to-the-bank' || state === 'queue' ? (
            commentary.bank_msg ? (
              <S.DetailCell>
                <S.SentBankOkIco />
                <S.TextWraper>{commentary.handleBankComment || checks.statusCheck}</S.TextWraper>
              </S.DetailCell>
            ) : (
              <S.DetailCell>
                <S.SentBankIco /> <S.TextWraper>{checks.statusCheck}</S.TextWraper>
              </S.DetailCell>
            )
          ) : (
            <S.DetailCell>
              {state === 'new'
                ? checks.statusCheck
                : commentary.handleApproveComment ||
                  commentary.handleStatusComment ||
                  checks.statusCheck}
            </S.DetailCell>
          )}
        </S.DealItemStatusContainer>
      ) : (
        <S.DealItemApprovedContainer
          isShowButton={actionButtonsPresenter.isShowActionButton}
          onMouseEnter={actionButtonsPresenter.handleMouseEnter}
          onMouseLeave={actionButtonsPresenter.handleMouseLeave}
          color={color}
          secondColor={secondColor}
          hasCarYear={checks.isShowYear}
        >
          {actionButtonsPresenter.isShowActionButton && (
            <DealActionButtons buttons={actionButtonsPresenter.buttons} />
          )}
          <S.DetailCell>
            <S.BankLogoIcon type="cps" id={bankId} />
            {bankName}
            {hasLeasing && <S.StyledBadge>Лизинг</S.StyledBadge>}
          </S.DetailCell>

          <S.DetailCell bold={boldItem.boldPrice}>
            {dealParams.creditSum}
            {boldItem.boldPrice && !checks.bankMaxSum && <S.DifferenceIco />}
            {checks.bankMaxSum && (
              <>
                <AreaInfo>
                  <S.InfoSvgStyled data-tip="" data-for="credit_sum" />
                  <ReactTooltipStyled id="credit_sum" place="top">
                    <span>{dealParams.maxLimit}</span>
                  </ReactTooltipStyled>
                </AreaInfo>
              </>
            )}
          </S.DetailCell>

          <S.DetailCell bold={boldItem.boldInitialMoney}>
            {dealParams.downPayment}
            {boldItem.boldInitialMoney && <S.DifferenceIco />}
          </S.DetailCell>

          <S.DetailCell bold={boldItem.boldPeriod}>
            {dealParams.term} {boldItem.boldPeriod && <S.DifferenceIco />}
          </S.DetailCell>

          <S.DetailCell bold={boldItem.boldRate}>
            {dealParams.rate} {boldItem.boldRate && <S.DifferenceIco />}
          </S.DetailCell>

          <S.DetailCell>{dealParams.monthly}</S.DetailCell>

          <S.DetailCell bold={boldItem.boldDealerSum}>
            {dealParams.dealerDopSum}
            {boldItem.boldDealerSum && Object.keys(dealer_details).length <= 1 && (
              <S.DifferenceIco />
            )}
            {Object.keys(dealer_details).length > 1 && (
              <ProductInfo id={`${deal.id}_dealerDetail`} productList={dealer_details} />
            )}
          </S.DetailCell>

          <S.DetailCell>
            {dealParams.bankDopSum}
            {Object.keys(bank_details).length > 1 && (
              <ProductInfo
                id={`${bankId}_bankDetail`}
                productList={bank_details}
                bankProduct={true}
              />
            )}
          </S.DetailCell>

          {checks.isShowYear && (
            <S.DetailCell bold={boldItem.boldYear}>
              {dealParams.carYearMax}
              {boldItem.boldYear && <S.DifferenceIco />}
            </S.DetailCell>
          )}
        </S.DealItemApprovedContainer>
      )}
    </>
  );
};
